module.exports = "/_next/static/images/cyber-security-trainings-d1b3aba2ba659d0af9cb64ddd6be2694.webp";